import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';

const PublicNavigation = () => (
  <Nav navbar className="ml-auto">
    <NavItem>
      <NavLink href="/login">Login</NavLink>
    </NavItem>
    <NavItem>
      <NavLink href="/signup">Signup</NavLink>
    </NavItem>
  </Nav>
);

export default PublicNavigation;
